<template>
    <div class="jump-cart">
        <van-nav-bar title="浏览历史" left-arrow fixed class="jump-nav-bar" @click-left="back"/>
        <div class="jump-cart-body">
            <div class="jump-cart-body-hd"></div>
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <van-row class="jump-cart-item" type="flex" v-for="item in list">
                    <van-col span="10" class="jump-cart-item-img">
                        <a :href="'#/gooddetail/'+item.goodsid"> <img :src="item.imgUrl"/></a>
                    </van-col>
                    <van-col span="14" class="jump-cart-item-warp">
                        <a :href="'#/gooddetail/'+item.goodsid"><p class="item-time">{{item.createtime}}</p>
                            <h4>{{item.goods_name}}</h4></a>
                        <p class="item-price" style="text-align: left">{{item.goods_price==null||item.goods_price==0?'已售罄':'￥'+item.goods_price}}
                            <i class="iconfont icon-lajitong" @click="delTrack(item.id)">&nbsp;&nbsp;&nbsp;</i>
                            <i class="iconfont icon-gouwuche" @click="addCarts(item.goodsid,1)" v-if="item.goods_type!=6">&nbsp;&nbsp;&nbsp;</i>
                        </p>
                    </van-col>
                </van-row>
            </van-list>
        </div>
        <BackTop />
    </div>
</template>
<script>
    import {NavBar, Row, Col, List} from "vant";

    export default {
        name: "userhistory",
        components: {
            [NavBar.name]: NavBar,
            [Row.name]: Row,
            [Col.name]: Col,
            [List.name]: List
        },
        data() {
            return {
                checkedAll: false,
                list: [],
                loading: false,
                finished: false,
                total: 0,
                page: 1
            };
        }, mounted: function () {
        },
        methods: {
            back() {
                history.back();
            }, onLoad() {
                let that = this
                // 异步更新数据
                that.$api.post(
                    that.jumuc.userCenter.selTrackListPage,
                    {"currentPage": that.page, "pageSize": 10},
                    successRes => {
                        let orderlist = successRes.data.list
                        for (let i = 0; i < orderlist.length; i++) {
                            that.list.push(orderlist[i]);
                        }
                        that.page = successRes.data.pageNum + 1
                        that.total = successRes.data.total
                        // 加载状态结束
                        that.loading = false;

                        // 数据全部加载完成
                        if (this.list.length >= that.total) {
                            that.finished = true;
                        }
                    }
                )

            }, addCarts(goood, count) {
                let that = this
                that.$api.post(
                    that.jumuc.cart.add,
                    {"goodsId": goood, "count": count,payment:1},
                    successRes => {
                        if (successRes.success) {
                            that.$router.push({
                                path: '/cart'
                            })
                        } else {
                            that.$toast(successRes.msg)
                        }
                    })
            },delTrack(id){
                let that = this
                that.$api.post(
                    that.jumuc.userCenter.delTrack,
                    {"id": id},
                    successRes => {
                        if (successRes.success) {
                            that.list=[]
                            that.page=1
                            that.onLoad()
                        } else {
                            that.$toast(successRes.msg)
                        }
                    })
            }
        }
    };
</script>
<style lang="less" scoped>
    @bule-thame: #3c6eeb;

    body {
        background-color: #f7f7f7;
    }

    .jump-cart {


        .van-hairline--bottom::after {
            border-bottom-width: 0px;
        }
        &-body {
            padding: 20px 10px 0;
            position: relative;
            &-hd {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 80px;
                background-color: @bule-thame;
            }
        }
        &-item {
            background-color: #fff;
            margin-bottom: 15px;
            align-items: center;
            border-radius: 20px;
            padding: 15px;
            position: relative;
            .van-checkbox {
                height: 100%;
                line-height: 100%;
            }
            &-img {
                img {
                    width: 90%;
                }
            }

            h4 {
                font-size: 14px;
                padding: 10px 0;
            }
            &-warp {
                align-self: flex-start;
            }
            p {
                font-size: 14px;
                &.item-time {
                    color: @bule-thame;
                    font-size: 16px;
                    text-align: right;
                }
                &.item-price {
                    color: red;
                    font-size: 16px;
                    i {
                        font-size: 18px;
                        float: right;
                        color: #f5a623
                    }
                }
            }
        }
    }
</style>

